import { Text } from '@chakra-ui/react'
import { ContainerVersion } from './styles'

interface SystemVersionProps {
    isOpen?: boolean
}

export const SystemVersion: React.FC<SystemVersionProps> = ({ isOpen }) => {
    return (
        <ContainerVersion open={isOpen}>
            <Text display="flex" justifyContent="center">
                {isOpen
                    ? `Versão: ${process.env.REACT_APP_VERSION}`
                    : `${process.env.REACT_APP_VERSION}`}
            </Text>
        </ContainerVersion>
    )
}
